import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';
import { setAccessToken } from "../../../mixins/insight/setAccessToken";
import moment from 'moment';
import { cloneDeep, get } from 'lodash';
import { QUERIES } from '../../../config/const';

const state = {
  query: {
    isBusy: false,
    data: null,
    error: null,
    sendToSave: false
  },
  run: {
    isBusy: false,
    data: null,
    error: null,
    pagination: {  currentPage: 1, perPage: 500, totalCount: 0, totalPages: 0 },
  },
  export: {
    isBusy: false,
    data: {
      state: null,
      file_url: null,
      row_received: null
    },
    error: null
  },
  bulkQueries: {
    isBusy: false,
    data: null,
    error: null
  },
  projectId: null,
};

const mutations = {
  LOAD_QUERY_BUSY: (state, payload) => {
    state.query.isBusy = payload;
  },
  LOAD_QUERY_SUCCESS: (state, payload) => {
    state.query.data = payload.data;
    state.query.error = null;
  },
  LOAD_QUERY_FAIL: (state, payload) => {
    state.query.data = null;
    state.query.error = payload;
  },
  
  EXPORT_QUERY_BUSY: (state, payload) => {
    state.export.isBusy = payload;
  },
  EXPORT_QUERY_SUCCESS: (state, payload) => {
    state.export.data = payload;
    state.export.error = null;
  },
  EXPORT_QUERY_FAIL: (state, payload) => {
    state.export.data = {
      state: null,
      file_url: null,
      row_received: null
    };
    state.export.error = payload;
  },
  RESET_QUERY_EXPORT(state) {
    state.export.data = {
      state: null,
      file_url: null,
      row_received: null
    };
  },

  RUN_QUERY_BUSY: (state, payload) => {
    state.run.isBusy = payload;
  },
  RUN_QUERY_SUCCESS: (state, payload) => {
    if(payload?.data?.pagination) state.run.pagination = {...state.run.pagination, ...payload?.data?.pagination};
    state.run.data = payload.data;
    state.run.error = null;
  },
  RUN_QUERY_FAIL: (state, payload) => {
    state.run.data = null;
    state.run.error = payload;
  },
  SET_RUN_QUERY_PAGINATION: (state, payload) => {
    state.run.pagination = payload;
  },

  SAVE_QUERY_BUSY: (state, payload) => {
    state.query.isBusy = payload;
  },
  SAVE_QUERY_SUCCESS: (state, payload) => {
    state.query.data = payload.data;
    state.query.error = null;

    if(state.query.sendToSave) state.query.sendToSave = false;
  },
  SAVE_QUERY_FAIL: (state, payload) => {
    state.query.data = null;
    state.query.error = payload;
  },

  SAVE_BULK_QUERIES_BUSY: (state, payload) => {
    state.bulkQueries.isBusy = payload;
  },
  SAVE_BULK_QUERIES_SUCCESS: (state, payload) => {
    state.bulkQueries.data = payload.data;
    state.bulkQueries.error = null;
  },
  SAVE_BULK_QUERIES_FAIL: (state, payload) => {
    state.bulkQueries.data = null;
    state.bulkQueries.error = payload;
  },

  UPDATE_QUERY: (state, payload) => {
    if(state.run.pagination.currentPage) state.run.pagination.currentPage = 1;
    state.query.data = payload;
  },
  UPDATE_FILTER_TAG: (state, { entry, breakdownId }) => {
    const updateFilter = state.query.data.filters.find(filter => {
      return filter.breakdown_id === breakdownId;
    });

    if (updateFilter) {
      updateFilter.name = entry.name;
      updateFilter.search_string = entry.search_string;
    }

    const updateRow = state.query.data.rows.find(filter => {
      return filter.breakdown_id === breakdownId;
    });

    if (updateRow) {
      updateRow.name = entry.name;
      updateRow.search_string = entry.search_string;
    }

    const updateColumns = state.query.data.columns.find(filter => {
      return filter.breakdown_id === breakdownId;
    });

    if (updateColumns) {
      updateColumns.name = entry.name;
      updateColumns.search_string = entry.search_string;
    }
  },
  UPDATE_QUERY_SETTINGS: (state, data) => {
    const updateFilter = state.query.data.filters.find(filter => {
      return filter.breakdown_id === data.breakdownId &&
        filter.id === data.entryId;
    });

    if (updateFilter) {
      Object.keys(data.settings).forEach(key => {
        updateFilter.settings[key].value = data.settings[key];
      });
    }

    const updateRow = state.query.data.rows.find(filter => {
      return filter.breakdown_id === data.breakdownId &&
        filter.id === data.entryId;
    });

    if (updateRow) {
      Object.keys(data.settings).forEach(key => {
        updateRow.settings[key].value = data.settings[key];
      });
    }

    const updateColumns = state.query.data.columns.find(filter => {
      return filter.breakdown_id === data.breakdownId &&
        filter.id === data.entryId;
    });

    if (updateColumns) {
      Object.keys(data.settings).forEach(key => {
        updateColumns.settings[key].value = data.settings[key];
      });
    }

    if (updateFilter || updateRow || updateColumns) {
      state.query.sendToSave = true;
    }
  },

  ADD_EXTERNAL_FILTER: (state, payload) => {
    let hasSameIndex = false;

    if (get(state, 'query.data.external_filters')) {
      hasSameIndex = state.query.data.external_filters
        .findIndex(item => {
          return (
            (payload.category_id && (item.category_id === payload.category_id || item.id === payload.category_id)) ||
            (payload.breakdown_id && item.breakdown_id === payload.breakdown_id) ||
            (payload.id && (item.id === payload.id || item.category_id === payload.id))
          )
        });
    } else {
      state.query.data = {
        external_filters: [],
      }
    }

    if (hasSameIndex !== -1)
      state.query.data.external_filters.splice(hasSameIndex, 1);
    
    state.query.data.external_filters.push(payload);
  },

  REMOVE_EXTERNAL_FILTER: (state, tagId) => {
    if (!tagId) return console.error('Has no tag id');

    const index = state.query.data.external_filters
      .findIndex(item => item.tag_id === tagId || item.id === tagId);

    if (index !== -1)
      state.query.data.external_filters.splice(index, 1);
  },

  UPDATE_PROJECT_ID: (state, payload) => {
    state.projectId = payload;
  }
};

const actions = {
  getQuery: ({ commit, rootState }, { projectId, queryId }) => {
    commit('LOAD_QUERY_BUSY', true);

    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    Axios
      .get(`${API_HOST}/projects/${projectId}/queries/${queryId}`, config)
      .then(response => {
        commit('LOAD_QUERY_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });

        console.error(error);
        commit('LOAD_QUERY_FAIL', error)
      })
      .finally(() => commit('LOAD_QUERY_BUSY', false));
  },

  exportQuery: async ({ commit, rootState }, { projectId, query, formatType, level, include_fulltext }) => {
    commit('EXPORT_QUERY_BUSY', true);

    const config = {
      headers: { Authorization: setAccessToken(rootState) },
      responseType: 'json'
    };

    try {
      const params = [`level=${level}`];
      if (include_fulltext) params.push('include_fulltext=true');
      const { data } = await Axios.post(`${API_HOST}/projects/${projectId}/queries/export/${formatType}?${params.join('&')}`, query, config)
      const uuid = data && data.stream_uuid
      const rezolution = await actions.streamExport(projectId, uuid, config, commit)

      const link = document.createElement('a');
      link.href = rezolution.file_url;
      const timestamp = moment().format('YYYYMMDD');
      link.setAttribute('download', `article_export_${timestamp}.${formatType}`)
      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        commit('EXPORT_QUERY_BUSY', false)
        commit('RESET_QUERY_EXPORT')
      }, 1500)

    } catch(e) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('messages.request.error')
      });
      commit('EXPORT_QUERY_FAIL', e)
      commit('RESET_QUERY_EXPORT')
    }
  },

  async streamExport(projectId, uuid, config, commit) {
    let errorCount = 0;
    const ERROR_COUNT_MAX = 100;

    function recursive(resolve, reject) {
      Axios.get(`${API_HOST}/projects/${projectId}/queries/export/uuid/${uuid}`, config)
        .then(({data: { data }}) => {
          commit('EXPORT_QUERY_SUCCESS', data )
          if(data.state === 'finished') {
            return resolve(data)
          }
          setTimeout(() => recursive(resolve, reject), 500);
        })
        .catch(e => {
          errorCount++
          if(errorCount >= ERROR_COUNT_MAX) return reject('Export Attempts Timeout')
          if(e && e.data && e.data &&  e.data.message && e.data.message.state &&  e.data.message.state === "finished") {
            return reject('Server error ' + (e.data.message.error || "missing error"))
          }
          console.error("ignoring error for now as the upload could still succeed");
          setTimeout(() => recursive(resolve, reject), 500);
        });
    }

    return new Promise((resolve, reject) => {
      return recursive(resolve, reject);
    });
  },

  runQuery: ({ commit, rootState, state }, { projectId, query } = {}) => {
    commit('RUN_QUERY_BUSY', true);

    if (projectId) commit('UPDATE_PROJECT_ID', projectId);
    if (!projectId && state.projectId) projectId = state.projectId;
    if (!query && get(state, 'query.data')) query = state.query.data;

    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    let _query = cloneDeep(query);
    // if limit is all, and no pagination, send default
    if(query?.limit === -1 && !Object.keys(_query?.pagination || {}).length) _query.pagination = state.run.pagination; 

    // Handle ranking settings from output settings
    if (_query?.output_settings) {
      const rankSettings = _query.output_settings.find(s => s.output_id === QUERIES.OUTPUTS.RANK);
      if (rankSettings && rankSettings.settings.rank_by_most_recent_period !== undefined) {
        _query.rank_by_most_recent_period = rankSettings.settings.rank_by_most_recent_period;
      }
      if (rankSettings && rankSettings.settings.rank_by_aggregated_value !== undefined) {
        _query.rank_by_aggregated_value = rankSettings.settings.rank_by_aggregated_value;
      }
    }

    if(Object.keys(_query?.pagination || {}).length) {
      // send a customLimit
      if(query.limit === -1 && _query?.pagination.perPage) _query.custom_limit = _query?.pagination.perPage;
      // for rank sorting, swap sort for the custom rankSort
      if(_query?.order?.name === 'rank' && _query?.sort) {
        _query.rankSort = _query?.sort === 'desc' ? 'asc' : 'desc';
        query.rankSort = _query.rankSort;
      }
      else if(query.rankSort) delete query.rankSort;
      // if not rank sort and rank in the output, send rank sort in desc
      if(_query?.order?.name !== 'rank' && _query?.sort === 'asc' && _query?.outputs?.includes(QUERIES.OUTPUTS.RANK)) _query.rankSort = 'desc';
      // set pagination
      commit('SET_RUN_QUERY_PAGINATION', _query?.pagination);
    }
    else commit('SET_RUN_QUERY_PAGINATION', {...state.run.pagination, currentPage: 1});

    Axios
      .post(`${API_HOST}/projects/${projectId}/queries/run`, _query, config)
      .then(response => {
        commit('RUN_QUERY_SUCCESS', response.data);
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.queries.run.error')
        });

        console.error(error);
        commit('RUN_QUERY_FAIL', error);
      })
      .finally(() => commit('RUN_QUERY_BUSY', false));
  },

  saveQuery: ({ commit, rootState }, { projectId, query: queryData }) => {
    commit('SAVE_QUERY_BUSY', true);
    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    if (!queryData.id) {
      return Axios
        .post(`${API_HOST}/projects/${projectId}/queries`, queryData, config)
        .then(response => {
          commit('SAVE_QUERY_SUCCESS', response.data)
          return response.data;
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')
          });

          console.error(error);
          commit('SAVE_QUERY_FAIL', error)
        })
        .finally(() => commit('SAVE_QUERY_BUSY', false));
    }
    else {
      return Axios
        .put(`${API_HOST}/projects/${projectId}/queries/${queryData.id}`, queryData, config)
        .then(response => {
          commit('SAVE_QUERY_SUCCESS', response.data)
          return response.data;
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')
          });

          console.error(error);
          commit('SAVE_QUERY_FAIL', error)
        })
        .finally(() => commit('SAVE_QUERY_BUSY', false));
    }
  },

  bulkUpdateQueries: ({ commit, rootState }, { projectId, queries }) => {
    commit('SAVE_BULK_QUERIES_BUSY', true);
    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    return Axios
      .put(`${API_HOST}/projects/${projectId}/queries/bulk_update`, queries, config)
      .then(response => {
        const data = response.data?.data || {};
        commit('SAVE_BULK_QUERIES_BUSY', data);
        const hasExcluded = Array.isArray(data?.excluded) && data?.excluded?.length > 0;
        Vue.notify({
          group: 'store_notifications',
          type: 'success',
          text: hasExcluded
            ? i18n.t('success_messages.bulk_update_queries_excluded', { count: data.excluded.length })
            : i18n.t('success_messages.bulk_update_queries')
        });
        return data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('error_messages.bulk_update_queries')
        });

        console.error(error);
        commit('SAVE_BULK_QUERIES_FAIL', error)
        throw error;
      })
      .finally(() => commit('SAVE_BULK_QUERIES_BUSY', false));
  },

  deleteQuery: ({ commit, rootState }, { projectId, queryId }) => {
    commit('LOAD_QUERY_BUSY', true);

    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    Axios
      .delete(`${API_HOST}/projects/${projectId}/queries/${queryId}`, config)
      .then((response) => {
        commit('LOAD_QUERY_SUCCESS', response.data)
        Vue.notify({
          group: 'store_notifications',
          type: 'success',
          text: i18n.t('messages.queries.delete_success')});
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_QUERY_FAIL', error)
      })
  },

  updateFilterTag: ({ commit, dispatch, state }, {
    entry,
    sendToSave,
    breakdownId,
    projectId
  }) => {
    commit('UPDATE_FILTER_TAG', { entry, breakdownId });

    if (sendToSave)
      dispatch('saveQuery', {
        projectId: projectId,
        query: state.query.data
      });
  },

  updateQuery: ({ commit }, query) => {
    commit('UPDATE_QUERY', query);
  },

  addExternalFilter: ({ commit, dispatch, state }, tag) => {
    commit('ADD_EXTERNAL_FILTER', tag);
    if (state.projectId && state.query.data) {
      dispatch('saveQuery', { projectId: state.projectId, query: state.query.data });
    }
    dispatch('runQuery');
  },

  removeExternalFilter: ({ commit, dispatch }, tagId) => {
    commit('REMOVE_EXTERNAL_FILTER', tagId);
    dispatch('runQuery');
  },

  updateQuerySettings({ commit, dispatch, state }, data) {
    commit('UPDATE_QUERY_SETTINGS', data);

    if(state.query.sendToSave) {
      let query = cloneDeep(state.query.data);
      query.order = {};
      query.sort = '';
      dispatch('saveQuery', {
        projectId: data.projectId,
        query: query
      });
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};